import { Component, OnInit, Inject, Optional } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { Observable } from 'rxjs';
import { DataService } from 'src/app/providers/data.service';
import { ClassService } from 'src/app/providers/class/class.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-class-modal',
  templateUrl: './class-modal.component.html',
  styleUrls: ['./class-modal.component.scss'],
  providers: [DataService]
})
export class ClassModalComponent implements OnInit {
  classForm: FormGroup;
  levels;
  local_data: any;
  id: number;

  public dataLevelList$: Observable<[]>;
  public dataSubjectList$: Observable<[]>;
  public dataSupervisorList$: Observable<[]>;
  //public dataClassSetList$: Observable<[]>;

  constructor(
    public fb: FormBuilder,
    public dialogRef: MatDialogRef<ClassModalComponent>,
    public dataService: DataService,
    private classService: ClassService,
    @Optional() @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {
    if (!this.data.id) {
      this.createForm();
    } else {
      this.editForm();
    }
  }

  createForm() {
    this.classForm = new FormGroup({
      classname: new FormControl(),
      Level_SysRef: new FormControl(),
      //Subject_SysRef: new FormControl(),
      Supervisor_SysRef: new FormControl(),
      //ClassSet_SysRef: new FormControl()
    });

    this.classForm = this.fb.group({
      classname: ['', [Validators.required]],
      Level_SysRef: ['', [Validators.required]],
      //Subject_SysRef: ['', [Validators.required]],
      Supervisor_SysRef: ['', [Validators.required]],
      //ClassSet_SysRef: ['', [Validators.required]]
      subjects: this.fb.array([])
    })
  }

  editForm() {
    this.classForm = new FormGroup({
      classname: new FormControl(),
      Level_SysRef: new FormControl(),
      //Subject_SysRef: new FormControl(),
      Supervisor_SysRef: new FormControl(),
      ///ClassSet_SysRef: new FormControl()
    });

    this.classForm = this.fb.group({
      classname: [this.data.className, [Validators.required] ],
      Level_SysRef: [this.data.level_sysref, [Validators.required]],
      //Subject_SysRef: [this.data.subject_sysref, [Validators.required]],
      Supervisor_SysRef: [this.data.supervisor_sysref, [Validators.required]],
      //ClassSet_SysRef: [this.data.classSet_sysref, [Validators.required]]
      subjects: this.fb.array([])
    })

    this.reAddSubjects();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    //level list
    this.dataLevelList$ = this.dataService.LevelList;
    this.dataService.getLevelData().subscribe();

    //subject list
    this.dataSubjectList$ = this.dataService.SubjectList;
    this.dataService.getSubjectData().subscribe();

    //supervisor list
    this.dataSupervisorList$ = this.dataService.SupervisorList;
    this.dataService.getSupervisorData().subscribe();

    //class set list
    //this.dataClassSetList$ = this.dataService.ClassSetList;
    //this.dataService.getClassSetData().subscribe();
  }

  addClass() {
    if (!this.data.id) {
      console.log(this.classForm.value);
      this.classService.addClass(this.classForm.value)
        .pipe(map(
          data => { console.log(data); return data },
          err => { console.log(err); return err }
        ))
        .subscribe(
          data => {
            return data;
          },
          err => { alert("Invalid data"); console.log(err) }
        );
    } else {
      console.log(this.classForm.value);
      this.classService.editClass(this.data.id, this.classForm.value)
        .pipe(map(
          data => { return data },
          err => { console.log(err); return err }
        ))
        .subscribe(
          data => {
            return data;
          },
          err => { alert("Invalid data"); console.log(err) }
        );
    }
  }

  subjects(): FormArray {
    return this.classForm.get('subjects') as FormArray
  }

  newSubject(): FormGroup {
    return this.fb.group({
      SysRef:new FormControl()
    })
  }

  addSubject() {
    this.subjects().push(this.newSubject());
  }

  reAddSubjects() {
    let Subjects = this.data.subjects;

    for (let i = 0; i < Subjects.length; i++) {
      let tmp = this.fb.group({
        SysRef: new FormControl(Subjects[i].sysRef)
      })

      this.subjects().push(tmp);
    }
  }
}
